module.exports = __webpack_public_path__ + "img/marker-now.8d0ea1db.svg";